import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import RMLandedCostTable from "./RMLandedCostTable";
import btnDownloadIcon from "../../../Assests/download-icon.svg";
import btnSaveIcon from "../../../Assests/Save-btn.svg";
import {
  EditProductTableSuccess,
  ViewProductTableError,
  ViewProductTableStart,
  ViewProductTableSuccess,
  enableEditFilter,
  loadCascadeOptions,
} from "../../../Redux/Actions/InputData";
import { postRequest, putRequest } from "../../../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  BULK_EDIT_MANUFACTURING_MASTER_TABLE_API,
  DISPLAY_MANUFACTURING_MASTER_1_TABLE_API,
  DOWNLOAD_MANUFACTURING_MASTER_1_TABLE_API,
  LONG_CASCADE_MASTER_DOWNLOAD_API,
  LONG_CASCADE_MASTER_GET_API,
  LONG_CASCADE_UPDATE_DATA_API,
  LONG_FACILITY_MASTER_GET_API,
  LONG_UPDATE_BULK_EDIT_RMLANDEDCOST_API,
  LONG_UPDATE_BULK_EDIT_RMLANDEDCOST_API_MODULE4,
  LT_RMLANDEDCOST_MODULE2,
  LT_RMLANDEDCOST_MODULE2_DOWNLOAD,
  LT_RMLANDEDCOST_MODULE4,
  LT_RMLANDEDCOST_MODULE4_DOWNLOAD,
  VIEW_MANUFACTURING_MASTER_1_TABLE_API,
} from "../../../Utils/Config";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import axios from "axios";
import FileSaver from "file-saver";
import "./style.css";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertProps } from "@mui/material/Alert";
import AddRowButton from "../../../Components/Common/AddRowButton";
import DeleteRowsButton from "../../../Components/Common/DeleteRowsButton";
import ConfirmationDialog from "../../../Components/Common/ConfirmationDialog";

function RMLandedCost(props: any) {
  const childRef: any = useRef();
  const dispatch: any = useDispatch();
  const [selectPlantDescription, setSelectPlantDescription] = useState<any>("");
  const [selectPlantCode, setSelectPlantCode] = useState<any>("");
  const [selectSFGCode, setSelectSFGCode] = useState<any>("");
  const [selectLandedCost, setSelectLandedCost] = useState<any>("");
  const [rowsData, setRows] = React.useState<any[]>([]);
  const [isProcessed, setIsProcessed] = React.useState(false);
  const [processingDescriptionOptions, setProcessingDescriptionOptions] =
    React.useState([]);
  const [processingPlantOptions, setProcessingPlantOptions] = useState<any>([]);
  const [timePeriodOptions, setTimePeriodOptions] = useState<any>([]);
  const [selectTime, setSelectTime] = useState<any>("");
  const [sfgCodeOptions, setSFGCodeOptions] = useState<any>([]);
  const [rmLandedCostOptions, setRMLandedCostOptions] = useState<any>([]);
  const [getEditedValue, setEditedValue] = useState<any>([]);
  const [open, setOpen] = React.useState(false);

  const [filterRequest, setFilterRequest] = React.useState([
    { key: "processing_Plant_Code", value: "" },
    { key: "processing_Plant_Description", value: "" },
    { key: "rM_Landed_Cost", value: "" },
    { key: "sfG_Code", value: "" },
    { key: "time_Period", value: "" },
  ]);

  const [filterModule4Request, setFilterModule4Request] = React.useState([
    { key: "packaging_Plant_Code", value: "" },
    { key: "packaging_Plant_Description", value: "" },
    { key: "rM_Landed_Cost", value: "" },
    { key: "product_Code", value: "" },
    { key: "time_Period", value: "" },
  ]);
  const processingDescriptionNames = processingDescriptionOptions?.sort(
    (a: any, b: any) =>
      a?.processing_Plant_Description.localeCompare(
        b?.processing_Plant_Description,
      ),
  );

  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deletedRows, setDeletedRows] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [isActionEnabled, setIsActionEnabled] = useState(false);
  const handleSelectionChange = (newSelection: any[]) => {
    setSelectedRows(newSelection);
    setIsActionEnabled(newSelection.length > 0);
  };
  // const rmLandedCostNames = rmLandedCostOptions?.sort((a: any, b: any) =>
  //   a.rM_Landed_Cost?.localeCompare(b.rM_Landed_Cost)
  // );

  var code = 0;
  var description = 0;
  var cost = 0;
  var sfgCode = 0;
  var time = 0;

  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId,
  );

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId,
  );

  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId,
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId,
  );

  const isEditPopup = useSelector(
    (state: any) => state.InputDataReducers.editPopupFlage,
  );

  const selectedTimePeriodData = useSelector(
    (state: any) => state.InputDataReducers.selectedTimePeriodData,
  );

  const selectedFolderData = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderData,
  );

  let folderModuleName = selectedFolderData?.folder?.slice(0, 7);
  const [tableName, setTableName] = useState<any>(
    "tblScenario_RMLandedCost_LT",
  );

  useEffect(() => {
    if (folderModuleName === "module2") {
      setTableName("tblScenario_RMLandedCost_LT_Module2");
      callTableGridApi("tblScenario_RMLandedCost_LT_Module2");
    } else if (folderModuleName === "module3") {
      setTableName("tblScenario_RMLandedCost_LT_Module3");
      callTableGridApi("tblScenario_RMLandedCost_LT_Module3");
    } else if (folderModuleName === "module4") {
      setTableName("tblScenario_RMLandedCost_LT_Module4");
      callTableGridApi("tblScenario_RMLandedCost_LT_Module4");
    } else if (folderModuleName === "module5") {
      setTableName("tblScenario_RMLandedCost_LT_Module5");
      callTableGridApi("tblScenario_RMLandedCost_LT_Module5");
    } else if (folderModuleName === "module6") {
      setTableName("tblScenario_RMLandedCost_LT_Module6");
      callTableGridApi("tblScenario_RMLandedCost_LT_Module6");
    } else {
      setTableName("tblScenario_CascadeMaster_LT");
      callTableGridApi("tblScenario_RMLandedCost_LT");
    }
  }, [folderModuleName, selectedScenarioId]);

  const handleChangeSelectPlantDescriptionCode = (event: any) => {
    setSelectLandedCost("");
    setSelectTime("");
    setSelectSFGCode("");
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    const {
      target: { value },
    } = event;
    setSelectPlantDescription(value);
    // filterRequest[1].value = value;
    folderModuleName === "module4"
      ? (filterModule4Request[1].value = value)
      : (filterRequest[1].value = value);

    callTableGridApi();
    code = 1;
    description = 1;
    cost = 0;
    sfgCode = 0;
    time = 0;
  };

  const handleChangeSFGCode = (event: any) => {
    setSelectTime("");
    const {
      target: { value },
    } = event;
    setSelectSFGCode(value);
    folderModuleName === "module4"
      ? (filterModule4Request[3].value = value)
      : (filterRequest[3].value = value);
    filterRequest[4].value = "";
    callTableGridApi();
    code = 1;
    description = 1;
    cost = 1;
    sfgCode = 1;
    time = 0;
  };

  const handleChangeLandedCostDescription = (event: any) => {
    setSelectSFGCode("");
    setSelectTime("");
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    const {
      target: { value },
    } = event;
    setSelectLandedCost(value);
    folderModuleName === "module4"
      ? (filterModule4Request[2].value = `${value}`)
      : (filterRequest[2].value = `${value}`);
    callTableGridApi();
    code = 1;
    description = 1;
    cost = 1;
    sfgCode = 0;
    time = 0;
  };

  const handleChangeSelectPlantCodeType = (event: any) => {
    setSelectLandedCost("");
    setSelectPlantDescription("");
    setSelectTime("");
    setSelectSFGCode("");
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    const {
      target: { value },
    } = event;
    setSelectPlantCode(value);
    folderModuleName === "module4"
      ? (filterModule4Request[0].value = value)
      : (filterRequest[0].value = value);
    callTableGridApi();
    code = 1;
    description = 0;
    cost = 0;
    sfgCode = 0;
    time = 0;
  };

  const handleChangeSelectTimePeriod = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectTime(value);
    filterRequest[4].value = value;
    callTableGridApi();
    code = 1;
    description = 1;
    cost = 1;
    sfgCode = 1;
    time = 1;
  };

  const handleDownload = (e: any) => {
    downloadXLSFile();
  };

  const downloadXLSFile = async () => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    const requestParam = {
      usecaseId: 0,
      category_id: 0,
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: tableName,
      time_period: "string",
      filter: filterList,
    };
    // const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing1Data", "filter": filterList };
    const urls =
      folderModuleName === "module4"
        ? API_BASE_URL + LT_RMLANDEDCOST_MODULE4_DOWNLOAD
        : API_BASE_URL + LT_RMLANDEDCOST_MODULE2_DOWNLOAD;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver(blob, Date.now() + ".xlsx");
    });
  };

  useEffect(() => {
    callTableGridApi();
  }, [
    selectedUsecaseId,
    selectedCategoryId,
    selectedFolderId,
    selectedScenarioId,
    selectedTimePeriodData,
  ]);
  const callTableGridApi = (selectedTable?: any) => {
    let timePeriodValues =
      selectedTimePeriodData !== undefined &&
      selectedTimePeriodData &&
      selectedTimePeriodData !== "Time Period" &&
      selectedTimePeriodData?.length > 0 &&
      selectedTimePeriodData[0] !== "Time Period" &&
      selectedTimePeriodData !== ""
        ? selectedTimePeriodData.join(",")
        : "";
    const filterData =
      folderModuleName === "module4" ? filterModule4Request : filterRequest;
    const filterList = filterData.filter((elem: any) => elem.value != "");
    console.log(filterList, selectedScenarioId, "scenario2");
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId
        : selectedScenarioId;
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: selectedTable ?? tableName,
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
      time_period: timePeriodValues,
    };

    dispatch(ViewProductTableStart());
    const urls =
      folderModuleName === "module4"
        ? API_BASE_URL + LT_RMLANDEDCOST_MODULE4
        : API_BASE_URL + LT_RMLANDEDCOST_MODULE2;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          setIsProcessed(true);

          setRows(response.data);
          if (sfgCode === 0) {
            folderModuleName === "module4"
              ? setSFGCodeOptions(loadSFGCodeModule4Options(response.data))
              : setSFGCodeOptions(loadSFGCodeOptions(response.data));
          }
          if (description === 0) {
            folderModuleName === "module4"
              ? setProcessingDescriptionOptions(
                  loadProcessingDescriptionModule4Options(response.data),
                )
              : setProcessingDescriptionOptions(
                  loadProcessingDescriptionOptions(response.data),
                );
          }
          if (cost === 0) {
            setRMLandedCostOptions(loadRMLandedCostOptions(response.data));
          }
          if (code === 0) {
            folderModuleName === "module4"
              ? setProcessingPlantOptions(
                  loadProcessingCodeModule4Options(response.data),
                )
              : setProcessingPlantOptions(
                  loadProcessingCodeOptions(response.data),
                );
          }
          if (time === 0) {
            setTimePeriodOptions(loadTimePeriodOptions(response.data));
          }
          dispatch(ViewProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const loadProcessingDescriptionOptions = (data: any) => {
    const processingDesOptions: any = [];
    data.map((item: any) => {
      const filteredItem = processingDesOptions.find((obj: any) => {
        return (
          obj.processing_Plant_Description === item.processing_Plant_Description
        );
      });
      if (filteredItem === undefined || filteredItem == null) {
        processingDesOptions.push({
          id: item.id,
          processing_Plant_Description: item.processing_Plant_Description,
        });
      }
    });
    return processingDesOptions;
  };

  const loadProcessingDescriptionModule4Options = (data: any) => {
    const processingDesOptions: any = [];
    data.map((item: any) => {
      const filteredItem = processingDesOptions.find((obj: any) => {
        return (
          obj.processing_Plant_Description === item.packaging_Plant_Description
        );
      });
      if (filteredItem === undefined || filteredItem == null) {
        processingDesOptions.push({
          id: item.id,
          processing_Plant_Description: item.packaging_Plant_Description,
        });
      }
    });
    return processingDesOptions;
  };

  const loadRMLandedCostOptions = (data: any) => {
    const rmLandedCostOptions: any = [];
    data.map((item: any) => {
      const filteredItem = rmLandedCostOptions.find((obj: any) => {
        return obj.rM_Landed_Cost === item.rM_Landed_Cost;
      });
      if (filteredItem === undefined || filteredItem == null) {
        rmLandedCostOptions.push({
          id: item.id,
          rM_Landed_Cost: item.rM_Landed_Cost,
        });
      }
    });
    return rmLandedCostOptions;
    //setProcessingDescriptionOptions(factoryOptions);
  };

  const loadSFGCodeOptions = (data: any) => {
    const sfgCodeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = sfgCodeOptions.find((obj: any) => {
        return obj.sfG_Code === item.sfG_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        sfgCodeOptions.push({ id: item.id, sfG_Code: item.sfG_Code });
      }
    });
    return sfgCodeOptions;
    //setProcessingDescriptionOptions(factoryOptions);
  };

  const loadSFGCodeModule4Options = (data: any) => {
    const sfgCodeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = sfgCodeOptions.find((obj: any) => {
        return obj.sfG_Code === item.product_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        sfgCodeOptions.push({ id: item.id, sfG_Code: item.product_Code });
      }
    });
    return sfgCodeOptions;
    //setProcessingDescriptionOptions(factoryOptions);
  };

  const loadProcessingCodeOptions = (data: any) => {
    console.log(data, "basepack");
    const processingPlantOptions: any = [];
    data.map((item: any) => {
      const filteredItem = processingPlantOptions.find((obj: any) => {
        return obj.processing_Plant_Code === item.processing_Plant_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        processingPlantOptions.push({
          id: item.id,
          processing_Plant_Code: item.processing_Plant_Code,
        });
      }
    });
    return processingPlantOptions;
  };
  const loadProcessingCodeModule4Options = (data: any) => {
    console.log(data, "basepack");
    const processingPlantOptions: any = [];
    data.map((item: any) => {
      const filteredItem = processingPlantOptions.find((obj: any) => {
        return obj.processing_Plant_Code === item.packaging_Plant_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        processingPlantOptions.push({
          id: item.id,
          processing_Plant_Code: item.packaging_Plant_Code,
        });
      }
    });
    return processingPlantOptions;
  };
  const loadTimePeriodOptions = (data: any) => {
    const timePeriodOptions: any = [];
    data.map((item: any) => {
      const filteredItem = timePeriodOptions.find((obj: any) => {
        return obj.time_Period === item.time_Period;
      });
      if (filteredItem === undefined || filteredItem == null) {
        timePeriodOptions.push({ id: item.id, time_Period: item.time_Period });
      }
    });
    return timePeriodOptions;
  };

  const getfiltersApi = (tableeName?: string) => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: tableeName ?? tableName,
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
      time_period: "",
    };

    dispatch(ViewProductTableStart());
    const urls =
      folderModuleName === "module4"
        ? API_BASE_URL + LT_RMLANDEDCOST_MODULE4
        : API_BASE_URL + LT_RMLANDEDCOST_MODULE2;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          console.log(response.data, "response");
          setIsProcessed(true);
          setRows(response.data);
          setProcessingDescriptionOptions(
            loadProcessingDescriptionOptions(response.data),
          );
          setProcessingPlantOptions(loadProcessingCodeOptions(response.data));
          setTimePeriodOptions(loadTimePeriodOptions(response.data));
          setSFGCodeOptions(loadSFGCodeOptions(response.data));
          setRMLandedCostOptions(loadRMLandedCostOptions(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const handleRestoreClicked = (e: any) => {
    setSelectPlantDescription("");
    setSelectPlantCode("");
    setSelectTime("");
    setSelectSFGCode("");
    setSelectLandedCost("");

    // getfiltersApi();
    filterRequest[0].value = "";
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    filterModule4Request[0].value = "";
    filterModule4Request[1].value = "";
    filterModule4Request[2].value = "";
    filterModule4Request[3].value = "";
    filterModule4Request[4].value = "";
    callTableGridApi(tableName);
  };

  // bulk edit

  const handleClearEditData = (val: any) => {
    console.log(val, "edited array");
  };

  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable,
  );

  const handleFetchEditData = (val: any) => {
    console.log(val, "edited array");
    setEditedValue(val);
  };

  const handleEditSave = (e: any) => {
    const requiredFields = [
      "processing_Plant_Code",
      "processing_Plant_Description",
      "sfG_Code",
      "sfG_Description",
      "time_Period",
      "rM_Landed_Cost",
    ];
    const allMissingFields = new Set<string>();
    getEditedValue.forEach((row: any) => {
      requiredFields.forEach((field) => {
        const value = row[field];
        if (value === undefined || value === null || value === "") {
          // Convert field name to readable format
          const fieldName = field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase());
          allMissingFields.add(fieldName);
        }
      });
    });

    if (allMissingFields.size > 0) {
      // Convert Set to Array and join
      const missingFieldsList = Array.from(allMissingFields).join(", ");

      setSnackbar({
        children: `Please fill the required fields: ${missingFieldsList}`,
        severity: "error",
      });
      return; // Prevent the save operation
    }

    handleClickOpen();
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddRow = () => {
    setRows((prev: any) => {
      const emptyRow = {
        id: new Date().getTime(),
        folder_id: selectedFolderId,
        scenario_id: selectedScenarioId,
        processing_Plant_Code: "",
        processing_Plant_Description: "",
        sfG_Code: "",
        sfG_Description: "",
        time_Period: 0,
        rM_Landed_Cost: 0,
      };
      return prev.length > 0 ? [...prev, emptyRow] : prev;
    });
  };
  const handleDeleteRows = () => {
    if (!selectedRows.length) return;
    setIsDeleteConfirmOpen(true);
  };

  const handleConfirmDeleteRows = () => {
    const updatedRows: any[] = [];
    const rowsToDelete: any[] = [];

    rowsData.forEach((row: any) => {
      if (selectedRows.includes(row.id)) {
        const updated = {
          ...row,
          folder_id: 0,
          folder_Id: 0,
          scenario_id: 0,
          isDelete: true,
        };
        rowsToDelete.push(updated);
      } else {
        updatedRows.push(row);
      }
    });

    setRows(updatedRows);

    if (rowsToDelete.length > 0) {
      // Store deleted rows separately
      setDeletedRows((prev: any[]) => [...prev, ...rowsToDelete]);

      setIsDeleteConfirmOpen(false);
      setSelectedRows([]);
      setIsActionEnabled(false);

      const dataToSave =
        getEditedValue && getEditedValue.length > 0
          ? [
              ...getEditedValue.filter(
                (row: any) => row && Object.keys(row).length > 0,
              ),
              ...rowsToDelete,
            ]
          : rowsToDelete;

      handleAgree(dataToSave, "Record deleted successfully");
    } else {
      setIsDeleteConfirmOpen(false);
    }
  };

  const handleAgree = (dataToSave: any[], successMessage: string) => {
    const transformedRows = dataToSave.map((row: any) => {
      if (row.isNew) {
        const { isNew, ...rest } = row;
        rest.id = 0;
        return rest;
      } else if (row.isDelete) {
        const { isDelete, ...rest } = row;
        rest.folder_id = 0;
        rest.Scenario_Id = 0;
        return rest;
      }

      return row;
    });
    const urls =
      folderModuleName === "module4"
        ? API_BASE_URL + LONG_UPDATE_BULK_EDIT_RMLANDEDCOST_API_MODULE4
        : API_BASE_URL + LONG_UPDATE_BULK_EDIT_RMLANDEDCOST_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    const payload = {
      moduleKey: Number(folderModuleName.slice(-1)),
      data: transformedRows,
    };

    putRequest(urls, payload, header, {})
      .then((response) => {
        if (response.status == 200) {
          callTableGridApi();
          setSnackbar({
            children: successMessage,
            severity: "success",
          });
          handleClose();
          childRef?.current?.ClearEditedData();
          dispatch(EditProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        setSnackbar({
          children: "Something went wrong please try again!",
          severity: "error",
        });
        handleClose();
      });
    // setTimeout(() => {
    //   props?.onClose();
    // }, 200);
  };

  // bulk edit

  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);

  const handleCloseSnackbar = () => setSnackbar(null);

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="Dialogbox-display"
      >
        <DialogTitle
          id="responsive-dialog-title"
          className="responsive-dialog-title-txt"
        >
          {"Confirmation for Edit"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="md-alert-clr">
            {getEditedValue.length > 0
              ? "Do you want to submit the edited RMLandedCost table data?"
              : "Please Edit any value to save!"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {getEditedValue.length > 0 ? (
            <>
              <Button className="modal-btn-b" autoFocus onClick={handleClose}>
                No
              </Button>
              <Button
                className="modal-btn-b"
                onClick={() =>
                  handleAgree(getEditedValue, "Successfully saved")
                }
                autoFocus
              >
                Yes
              </Button>
            </>
          ) : (
            <Button className="modal-btn-b" autoFocus onClick={handleClose}>
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
        onConfirm={handleConfirmDeleteRows}
        title="Confirmation for Delete"
        page="RM Landed Cost"
        confirmText="Yes"
        cancelText="No"
        fullScreen={fullScreen}
      />
      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3>RM Landed Cost</h3>
          </div>
          <div className="filters">
            <span title="Reset">
              <RestoreOutlinedIcon
                className="restoreIcon"
                onClick={(e) => handleRestoreClicked(e)}
              />
            </span>
            <AddRowButton
              isEditEnabled={isEditEnabled && !isActionEnabled}
              handleAddRow={handleAddRow}
            />
            <DeleteRowsButton
              isEditEnabled={isEditEnabled && isActionEnabled}
              handleDeleteRows={handleDeleteRows}
            />
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Facility Type</InputLabel> */}
                {/* <InputLabel>Facility Code</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectPlantCode}
                  placeholder="Select Basepack"
                  onChange={handleChangeSelectPlantCodeType}
                  // renderValue={(selectPlantCode: any) => selectPlantCode}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    {folderModuleName === "module4" ? (
                      <em>Packaging Plant Code</em>
                    ) : (
                      <em>Processing Plant Code</em>
                    )}
                  </MenuItem>
                  {processingPlantOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.processing_Plant_Code}>
                        {d.processing_Plant_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Facility Code</InputLabel> */}
                {/* <InputLabel>Cascade</InputLabel> */}
                <Select
                  id="simple-select-1"
                  value={selectPlantDescription}
                  placeholder="Select Factory"
                  onChange={handleChangeSelectPlantDescriptionCode}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    {folderModuleName === "module4" ? (
                      <em>Packaging Plant Description</em>
                    ) : (
                      <em>Processing Plant Description</em>
                    )}
                  </MenuItem>
                  {processingDescriptionNames?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.processing_Plant_Description}>
                        {d.processing_Plant_Description}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Cascade</InputLabel> */}
                {/* <InputLabel>Facility Type</InputLabel> */}
                <Select
                  id="simple-select-2"
                  value={selectSFGCode}
                  placeholder="Select Cascade"
                  onChange={handleChangeSFGCode}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    {folderModuleName === "module4" ? (
                      <em>Product Code</em>
                    ) : (
                      <em>SFG Code</em>
                    )}
                  </MenuItem>
                  {sfgCodeOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.sfG_Code}>
                        {d?.sfG_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Facility Description</InputLabel> */}
                <Select
                  id="simple-select-3"
                  value={selectLandedCost}
                  placeholder="Select Line"
                  onChange={handleChangeLandedCostDescription}
                  // renderValue={(selectLandedCost: any) => selectLandedCost}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>RM Landed Cost</em>
                  </MenuItem>
                  {rmLandedCostOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.rM_Landed_Cost}>
                        {d.rM_Landed_Cost}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>

            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Flag</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectTime}
                  placeholder="Select Basepack"
                  onChange={handleChangeSelectTimePeriod}
                  // renderValue={(selectTime: any) => selectTime}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Time Period</em>
                  </MenuItem>
                  {timePeriodOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.time_Period}>
                        {d?.time_Period}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {isEditEnabled && isEditPopup && (
              <FormControl fullWidth>
                <div
                  className="content-save-btn"
                  onClick={(e) => handleEditSave(e)}
                >
                  <img src={btnSaveIcon} alt="" /> <span> Save</span>
                </div>
              </FormControl>
            )}

            <div className="filter-item">
              <FormControl fullWidth>
                <div
                  className="content-download-btn"
                  onClick={(e) => handleDownload(e)}
                >
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
      </div>
      <div>
        <RMLandedCostTable
          ref={childRef}
          isProcessed={isProcessed}
          rowsData={rowsData}
          handleGetEditData={handleFetchEditData}
          handleClearEditData={handleClearEditData}
          setRows={setRows}
          handleSelectionChange={handleSelectionChange}
          selectedRows={selectedRows}
        />
        {!!snackbar && (
          <Snackbar
            open
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseSnackbar}
            autoHideDuration={6000}
          >
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}
      </div>
    </>
  );
}

export default RMLandedCost;
